import React, {
  createContext,
  useContext,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react';

import Confirmation from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Confirmation';
import Step0 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step0';
import Step1 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step1';
import Step2 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step2';
import Step3 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step3';
import Step4 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step4';
import Step5 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step5';
import Step6 from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Step6';
import Summary from '../../screens/PrivateLayout/Inspections/components/SinisterInspections/ownFlow/Summary';
import { uploadInspectionPhoto } from '../../services/sinisterInspections/sinisterInspections.service';
import SinsiterInspectionReducer, {
  CLEAN_SINISTER_INSPECTION_SUCCESS,
  FAILURE_SINISTER_INSPECTION_BY_ID,
  FAILURE_UPLOAD_PHOTO,
  REQUEST_SINISTER_INSPECTION_BY_ID,
  REQUEST_UPLOAD_PHOTO,
  SUCCESS_SINISTER_INSPECTION_BY_ID,
  SUCCESS_UPLOAD_PHOTO,
  UPDATE_SINISTER_INSPECTION_BODY,
} from './SinisterInspections.reducer';

export const SinisterInspectionsContext = createContext<any>(null);

const initialState = {
  incidents: [],
  incident: {},
  sinister_inspection_body: {},
  image_preview: [],
  loading: false,
};

const SinisterInspectionsProvider = ({ ...props }) => {
  const [step, setStep] = useState(0);
  const [state, dispatch] = useReducer(SinsiterInspectionReducer, initialState);
  const STEPS = useRef([
    {
      title: 'Coordinar inspección en taller',
      content: <Step0 />,
      order: 1,
    },
    {
      title: 'Datos de taller',
      content: <Step1 />,
      order: 2,
    },
    {
      title: 'Fecha de la inspección',
      content: <Step2 />,
      order: 3,
    },
    {
      title: 'Lugar de la inspección',
      content: <Step3 />,
      order: 4,
    },
    {
      title: 'Información adicional',
      content: <Step4 />,
      order: 5,
    },
    {
      title: 'Resumen',
      content: <Summary />,
      order: 8,
    },
    {
      title: 'Pedido de inspección confirmado',
      content: <Confirmation />,
      order: 9,
    },
  ]);

  const nextStep = () => {
    setStep(step + 1);
  };

  const goBack = (jump?: number) => {
    jump ? setStep(step - jump) : setStep(step - 1);
  };

  const selectSinisterInspection = async (id: number, incidents: any) => {
    dispatch({
      type: REQUEST_SINISTER_INSPECTION_BY_ID,
    });

    const selectedIncident = incidents.filter((incident) => incident.id === id);

    try {
      dispatch({
        type: SUCCESS_SINISTER_INSPECTION_BY_ID,
        payload: selectedIncident[0],
      });
    } catch (err) {
      dispatch({
        type: FAILURE_SINISTER_INSPECTION_BY_ID,
      });
    }
  };

  const updloadPhotos = async (formData: any, incident_id) => {
    dispatch({
      type: REQUEST_UPLOAD_PHOTO,
      payload: formData,
    });

    const form = new FormData();
    for (const key in formData) {
      if (Object.prototype.hasOwnProperty.call(formData, key)) {
        if (formData[key]) {
          form.append(key, formData[key]);
        }
      }
    }

    try {
      const res = await uploadInspectionPhoto(form, incident_id);
      dispatch({
        type: SUCCESS_UPLOAD_PHOTO,
        payload: res.data,
      });
    } catch (err) {
      const data = {
        ...err.response?.data,
        status: err?.response?.status,
      };
      dispatch({
        type: FAILURE_UPLOAD_PHOTO,
        payload: data,
      });
    }
  };

  const updateSinisterInspectionBody = (body) => {
    dispatch({
      type: UPDATE_SINISTER_INSPECTION_BODY,
      payload: body,
    });
  };

  const cleanSuccess = () => {
    dispatch({
      type: CLEAN_SINISTER_INSPECTION_SUCCESS,
    });
  };

  const flowHasPhotos = (hasPhotos: boolean) => {
    if (hasPhotos === true) {
      STEPS.current.push(
        {
          title: 'Frente del presupuesto',
          content: <Step5 />,
          order: 6,
        },
        {
          title: 'Dorso del presupuesto',
          content: <Step6 />,
          order: 7,
        }
      );
      STEPS.current.sort((a, b) => (a.order > b.order ? 1 : -1));
    } else {
      STEPS.current = STEPS.current.filter(
        (element) =>
          element.title !== 'Frente del presupuesto' &&
          element.title !== 'Dorso del presupuesto'
      );
      STEPS.current.sort((a, b) => (a.order > b.order ? 1 : -1));
    }
  };

  const SinisterInspectionsValue = useMemo(
    () => ({
      ...state,
      selectSinisterInspection,
      nextStep,
      goBack,
      step,
      updateSinisterInspectionBody,
      updloadPhotos,
      cleanSuccess,
      STEPS,
      flowHasPhotos,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, step]
  );

  return (
    <SinisterInspectionsContext.Provider
      value={SinisterInspectionsValue}
      {...props}
    />
  );
};

export const useSinisterInspectionsContext = () =>
  useContext(SinisterInspectionsContext);

export default SinisterInspectionsProvider;
